import PageBreadcrumb from "@/components/common/PageBreadCrumb";
import Label from "@/components/Usados/Label";
import Button from "@/components/ui/button/Button";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { ChevronLeft } from "lucide-react";
import { apiFetch } from "@/service/api";

export default function ViewUsuario() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUsuario = async () => {
      try {
        const response = await apiFetch(`usuarios/find-one/${id}`);
        if (response.ok) {
          const data = await response.json();
          setUsuario(data);
        } else {
          setError("No se pudo cargar la informacion del usuario.");
        }
      } catch (err) {
        console.error("Error fetching usuario:", err);
        setError("Error de conexion al cargar los datos.");
      } finally {
        setLoading(false);
      }
    };
    fetchUsuario();
  }, [id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500"></div>
      </div>
    );
  }

  if (error || !usuario) {
    return (
      <div className="p-5 text-center text-red-500">
        {error || "Usuario no encontrado"}
      </div>
    );
  }

  return (
    <div>
      <PageBreadcrumb pageTitle="Detalles del Usuario" />
      <div className="mb-6">
        <button
          onClick={() => navigate("/seguridad_accesos/usuarios")}
          className="inline-flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
        >
          <ChevronLeft className="size-5" />
          Volver al listado
        </button>
      </div>
      <div className="rounded-2xl border border-gray-200 bg-white px-5 py-7 dark:border-gray-800 dark:bg-white/[0.03] xl:px-10 xl:py-12">
        <div className="flex flex-col gap-8">
          <div className="border-b border-gray-100 pb-5 dark:border-gray-800">
            <h3 className="text-xl font-bold text-gray-800 dark:text-white/90">
              {usuario.nombres} {usuario.apellidos}
            </h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              ID: {usuario.id}
            </p>
          </div>
          <div className="grid grid-cols-1 gap-y-6 md:grid-cols-2 md:gap-x-12">
            <div>
              <Label className="mb-1 text-gray-400 uppercase text-xs">
                Correo Electronico
              </Label>
              <p className="text-gray-800 dark:text-white/90 font-medium">
                {usuario.correo_electronico}
              </p>
            </div>
            <div>
              <Label className="mb-1 text-gray-400 uppercase text-xs">
                Telefono
              </Label>
              <p className="text-gray-800 dark:text-white/90 font-medium">
                {usuario.telefono || "No registrado"}
              </p>
            </div>
            <div>
              <Label className="mb-1 text-gray-400 uppercase text-xs">
                Fecha de Nacimiento
              </Label>
              <p>
                {usuario.fecha_nacimiento
                  ? usuario.fecha_nacimiento
                      .split("T")[0]
                      .split("-")
                      .reverse()
                      .join("/")
                  : "No registrada"}
              </p>
            </div>
            <div>
              <Label className="mb-1 text-gray-400 uppercase text-xs">
                Fecha de Creacion
              </Label>
              <p className="text-gray-800 dark:text-white/90 font-medium">
                {new Date(usuario.fecha_creacion).toLocaleString()}
              </p>
            </div>
          </div>
          <div className="mt-10 flex justify-end">
            <Button
              variant="primary"
              size="md"
              onClick={() =>
                navigate(`/seguridad_accesos/usuarios/update/${usuario.id}`)
              }
            >
              Editar Usuario
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
